import { render } from "./CoverButtonIcon.vue?vue&type=template&id=1ddbbc91"
import script from "./CoverButtonIcon.vue?vue&type=script&lang=js"
export * from "./CoverButtonIcon.vue?vue&type=script&lang=js"

import "./CoverButtonIcon.vue?vue&type=style&index=0&id=1ddbbc91&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__